import React from 'react'

function Spinner({ sm }) {
    return (
        <div className='text-center'><span className={`spinner-border spinner-border-${sm && "sm"}`}></span></div>
    )
}

export default Spinner